export default __webpack_public_path__ + "static/media/16.f92b7d31.pdf";